import Input from "../../../components/UIElements/Input";
import { Typography } from "@mui/material";
import { useState } from "react";
import { createOrder as handlCreate } from "../../../service";
import { useCustomSnackbar } from "../../../components/Misc/useSnackbar";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../redux/actions";

const OrderCreateModalContent = ({ onCancel }) => {
  const [invoiceId, setInvoiceId] = useState("");
  const toast = useCustomSnackbar();
  const dispatch = useDispatch();
  const createOrder = async () => {
    onCancel();
    dispatch(setLoading({stat: true, text: 'Creating Order'}));
    const { statusCode } = await handlCreate(invoiceId);
    if (statusCode === 200) {
      toast({
        message: "Order has been placed successfully.",
        type: "success",
      });
    } else {
      toast({
        message: statusCode === 404 ? "Invoice not found" : "Bad Request",
        type: "error",
      });
    }
    dispatch(setLoading(false));
  };

  return (
    <div className="md:px-17.5 w-full max-w-230 rounded-lg bg-white px-8 py-12 dark:bg-boxdark md:py-15">
      <div className="mb-4.5 flex flex-col gap-6">
        <Typography variant="h5" className="text-white">
          Create Web Order from invoice and send it to fulfillment
        </Typography>
        <div className="w-full">
          <Input
            placeholder="The Invoice ID"
            label="The Invoice ID"
            onChange={(e) => setInvoiceId(e.target.value)}
            value={invoiceId}
          />
        </div>
      </div>
      <div className="-mx-3 flex flex-wrap gap-y-4">
        <div className="2xsm:w-1/2 w-full px-3">
          <button
            onClick={onCancel}
            className="block w-full rounded border border-stroke bg-gray p-3 text-center font-medium text-black transition hover:border-meta-1 hover:bg-meta-1 hover:text-white dark:border-strokedark dark:bg-meta-4 dark:text-white dark:hover:border-meta-1 dark:hover:bg-meta-1"
          >
            Cancel
          </button>
        </div>
        <div className="2xsm:w-1/2 w-full px-3">
          <button
            onClick={createOrder}
            className="block w-full rounded border border-primary bg-primary p-3 text-center font-medium text-white transition hover:bg-opacity-90"
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
};
export default OrderCreateModalContent;
